import React from 'react';
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';

const BaseModal = ({
  isOpen,
  onClose,
  title,
  subtitle,
  icon,
  children,
  footer,
  className = '',
}) => {
  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div 
        style={{
          position: 'fixed',
          inset: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          zIndex: 50,
          backdropFilter: 'blur(8px)'
        }}
        aria-hidden="true" 
      />
      
      <div 
        style={{
          position: 'fixed',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '16px',
          zIndex: 60
        }}
      >
        <DialogPanel 
          style={{
            width: '100%',
            maxWidth: window.innerWidth < 640 ? '95vw' : '448px', // Responsive max width
            backgroundColor: 'rgba(17, 24, 39, 0.95)',
            backdropFilter: 'blur(20px)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            borderRadius: '16px',
            padding: window.innerWidth < 640 ? '20px' : '32px', // Responsive padding
            boxShadow: '0 25px 50px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.1)',
            color: 'white',
            textAlign: 'left',
            position: 'relative',
            maxHeight: '90vh', // Prevent overflow on small screens
            overflowY: 'auto' // Allow scrolling if content is too long
          }}
        >
          {/* Header */}
          <div style={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            marginBottom: window.innerWidth < 640 ? '20px' : '32px' // Responsive spacing
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px'
            }}>
              {icon && (
                <div style={{
                  height: '56px',
                  width: '56px',
                  background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
                  borderRadius: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 8px 32px rgba(59, 130, 246, 0.3)',
                  border: '1px solid rgba(255, 255, 255, 0.2)'
                }}>
                  <span style={{
                    fontSize: '28px',
                    filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))'
                  }}>{icon}</span>
                </div>
              )}
              <div>
                <DialogTitle 
                  as="h3"
                  style={{
                    fontSize: '20px',
                    fontWeight: '600',
                    color: 'white',
                    margin: '0',
                    textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
                  }}
                >
                  {title}
                </DialogTitle>
                {subtitle && (
                  <p style={{
                    fontSize: '14px',
                    color: 'rgba(255, 255, 255, 0.7)',
                    marginTop: '4px',
                    textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
                  }}>
                    {subtitle}
                  </p>
                )}
              </div>
            </div>
            <button
              onClick={onClose}
              style={{
                height: window.innerWidth < 640 ? '48px' : '44px', // Larger on mobile
                width: window.innerWidth < 640 ? '48px' : '44px', // Larger on mobile
                backgroundColor: 'rgba(255, 255, 255, 0.15)',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                borderRadius: '12px',
                color: 'white',
                fontSize: '20px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                backdropFilter: 'blur(10px)',
                textShadow: '0 1px 2px rgba(0, 0, 0, 0.5)',
                // Better touch feedback
                WebkitTapHighlightColor: 'rgba(255, 255, 255, 0.2)',
                userSelect: 'none'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.25)';
                e.target.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.15)';
                e.target.style.transform = 'scale(1)';
              }}
            >
              <svg 
                style={{
                  width: '20px',
                  height: '20px',
                  fill: 'none',
                  stroke: 'currentColor',
                  viewBox: '0 0 24 24',
                  strokeWidth: '2.5'
                }}
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  d="M6 18L18 6M6 6l12 12" 
                />
              </svg>
            </button>
          </div>

          {/* Body */}
          <div style={{
            marginBottom: window.innerWidth < 640 ? '20px' : '32px' // Responsive spacing
          }}>
            {children}
          </div>

          {/* Footer */}
          {footer && (
            <div style={{
              display: 'flex',
              gap: window.innerWidth < 640 ? '12px' : '16px', // Responsive gap
              marginBottom: window.innerWidth < 640 ? '20px' : '32px' // Responsive spacing
            }}>
              {footer}
            </div>
          )}
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default BaseModal;
